import { Box, Button, Typography } from '@mui/material';
import { useUserContext } from '@schooly/components/authentication';
import React, { useLayoutEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import buildClassName from '../../utils/buildClassName';

const NotFoundPage: React.FC = () => {
  const { user } = useUserContext();

  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { $t } = useIntl();

  useLayoutEffect(() => {
    // hide if modal open
    setTimeout(() => {
      const modalRoot = document.querySelector('#modal-root');

      const isModalRootEmpty = modalRoot?.children.length === 0;

      if (isModalRootEmpty && !user) {
        navigate('/');
        return;
      }

      setVisible(isModalRootEmpty);
    }, 0);
  }, [user, navigate]);

  return (
    <main className={buildClassName('center-contents', 'hidden', visible && 'visible')}>
      <Box mb={4}>
        <picture>
          <source srcSet="/images/no-schools.png, /images/no-schools@2x.png 2x" />
          <img src="/images/no-schools.png" alt={$t({ id: 'notfound-message' })} />
        </picture>
      </Box>
      <Typography variant="h2" mb={6}>
        {$t({ id: 'notfound-message' })}
      </Typography>

      <Button onClick={() => navigate('/')}>{$t({ id: 'returnToHome' })}</Button>
    </main>
  );
};

export default NotFoundPage;
